import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Grid, Box, Card, Text, Button, SimpleGrid } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import * as actions from '../../../actions/Logradouro';
import LogradouroMap from './Map';
import LogradouroSearch from './Search';
import { DetailSkeleton } from '../../../components/TableSkeleton';
import { useAppDispatch } from '../../../store/hooks';
import { useOptionalLogradourosMap } from '../../../components/Logradouros/LogradourosMapContext';
import type { LogradouroItem } from '../../../store/types';

export default function LogradouroView() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const [logradouro, setLogradouro] = useState<LogradouroItem | null>(null);
  const logradourosMap = useOptionalLogradourosMap();
  const inShell = !!logradourosMap;
  const setShellGeoJson = logradourosMap?.setGeoJson;
  const setShellSelectedId = logradourosMap?.setSelectedId;

  useEffect(() => {
    if (!id) return;
    dispatch((actions as any).get(id, (response: { data: LogradouroItem }) => {
      setLogradouro(response.data);
    }));
  }, [id, dispatch]);

  // Publica geoJson do logradouro selecionado no overlay do shell.
  useEffect(() => {
    if (!setShellGeoJson || !setShellSelectedId) return;
    setShellGeoJson(logradouro?.geoJson ?? null);
    setShellSelectedId(logradouro ? String(logradouro.id) : null);
    return () => { setShellGeoJson(null); };
  }, [setShellGeoJson, setShellSelectedId, logradouro]);

  if (!logradouro) return <DetailSkeleton lines={10} />;

  return (
    <Box>
      {!inShell && <LogradouroSearch page={1} pageSize={8} />}

      <Grid gap="md" mt="md">
        <Grid.Col span={{ base: 12, md: inShell ? 12 : 6 }}>
          <Card withBorder shadow="sm" padding="md">
            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="xs">
              {logradouro.fieldItemGroups?.map((itemGroup) =>
                itemGroup.fieldItems.map((fieldItem) => (
                  <Box key={fieldItem.label}>
                    <Text size="sm">
                      <Text component="span" fw={600}>{fieldItem.label}: </Text>
                      {fieldItem.value}
                    </Text>
                  </Box>
                ))
              )}
            </SimpleGrid>
          </Card>

          <Button
            mt="md"
            variant="default"
            leftSection={<IconArrowLeft size={16} />}
            onClick={() => navigate(-1)}
          >
            Voltar
          </Button>
        </Grid.Col>
        {!inShell && (
          <Grid.Col span={{ base: 12, md: 6 }}>
            <LogradouroMap geoJson={logradouro.geoJson} />
          </Grid.Col>
        )}
      </Grid>
    </Box>
  );
}
